export default __webpack_public_path__ + "static/media/Xmas2024Front.2a58a453.png";